import { FIND_USER } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";

async function getAllCompany(props: IFindUserInformation) {
  var thisUrl = FIND_USER + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;

  const populateFields =
    "userTypes avatar balance wallet blocks financial companyInformation.documents companyInformation.isFavorite companyInformation.isDriverWallet companyInformation.financialGroupSchool companyInformation.city companyInformation.province companyInformation.nationalCode companyInformation.approved companyInformation.address companyInformation.companyName companyInformation.superAgent companyInformation.nationalId companyInformation.registrationNumber companyInformation.isAdminPozMachine";

  thisUrl += `&populate=${populateFields}`;

  let body: any = {
    query: {
      userTypes: {
        $in: ["COMPANY"],
      },
    },
  };

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    if (props?.search?.base === "companyInformation.companyName") {
      body = {
        query: {
          ...body.query,
          "companyInformation.companyName": { $regex: props?.search?.value },
        },
      };
    } else if (props?.search?.base === "nationalCode") {
      body = {
        query: {
          ...body.query,
          "companyInformation.nationalCode": { $regex: props?.search?.value },
        },
      };
    } else {
      body = {
        query: {
          ...body.query,
          [String(props.search.base)]: utils.convertNumbers2English(
            props.search.value
          ),
        },
      };
    }
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.filters) {
    const { province, isFavorite, city, superAgent, approved } = props.filters;
    body = {
      query: {
        ...body.query,
        isFavorite: isFavorite,
        "companyInformation.province": province,
        "companyInformation.city": city,
        "companyInformation.superAgent": superAgent,
        "companyInformation.approved.isApproved": approved?.value,
      },
    };

    // if (province) query({ target: "province", value: province?._id });
    // if (city) query({ target: "city", value: city?._id });
    // if (superAgent) query({ target: "superAgent", value: superAgent?._id });
  }

  // !! ---------------------------------------------------------------------------------------------------------------------
  // !! =====================================================================================================================
  // !!                                            Try Catch For SuperAgent
  // !! =====================================================================================================================
  // !! ---------------------------------------------------------------------------------------------------------------------

  // ?? Academic year (سال تحصیلی) scope. Set last, and on the body root rather than inside `query`, because the
  // ?? search and filter branches above rebuild `body` wholesale and would otherwise drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default getAllCompany;
